var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('iframe',{ref:"iframe",attrs:{"id":"iframe","src":"forum/列表.html"},on:{"load":_vm.loaded}})])}
var staticRenderFns = []

export { render, staticRenderFns }